import React, { useEffect } from 'react';
import Button from 'components/common/button';
import CheckCircleIcon from 'assets/svg/CheckCircleIcon';
import { getAccessInfo } from 'utils/helper';
import { useRouter } from 'next/router';

type CompletionMessageProps = {
  title: string;
  message: string;
  actionLabel?: string;
  actionHref?: string;
};

function CompletionMessage({
  title,
  message,
  actionLabel,
  actionHref,
}: CompletionMessageProps) {
  const showAction = actionLabel && actionHref;
  const { query } = useRouter();
  const { canAccessPatientPortal } = getAccessInfo(query);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="mx-auto mt-8 flex w-full max-w-xl flex-col items-center rounded-2xl border border-[#e7edf3] bg-white px-5 py-8 text-center shadow-[0_4px_20px_rgba(27,39,94,0.08)] sm:mt-12 sm:px-10 sm:py-12">
      <div className="mb-6 flex h-18 w-18 items-center justify-center rounded-full bg-[#edf4f4] sm:mb-8 sm:h-24 sm:w-24">
        <CheckCircleIcon className="!h-12 !w-12 !text-populate-green sm:!h-16 sm:!w-16" />
      </div>
      <h2 className="text-2xl font-semibold leading-none text-[#18213f] md:text-3xl">
        {title}
      </h2>
      <p className="mt-3 max-w-xl text-sm leading-6 text-[#5f6f8e] sm:mt-4 sm:text-base sm:leading-7">
        {message}
      </p>
      {showAction && canAccessPatientPortal ? (
        <Button
          href={actionHref}
          classWrap="!mt-8 !w-full sm:!mt-10"
          className="!h-[62px] !w-full !rounded-full !bg-populate-green !px-8 !text-lg !font-normal !normal-case !tracking-[-0.01em] hover:!bg-populate-deep-green sm:!h-[72px] sm:!text-[20px]"
        >
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
}

export default CompletionMessage;
